// A stream can receive tracks after being attached to the video element.
export function attachMediaPlayback(element, stream, muted, onState) {
  let disposed = false;
  let attempt = 0;
  let silent = muted;
  const tracks = new Set();
  const play = async (userGesture = false) => {
    if (disposed || !stream) return;
    const current = ++attempt;
    if (userGesture) silent = muted;
    element.muted = silent;
    try {
      await element.play();
      if (!disposed && current === attempt) onState(silent && !muted ? 'sound' : null);
    } catch (error) {
      if (disposed || current !== attempt) return;
      if (error.name === 'NotAllowedError' && !element.muted) {
        silent = true;
        element.muted = true;
        try {
          await element.play();
          if (!disposed && current === attempt) onState('sound');
          return;
        } catch { /* Keep a visible manual retry for browsers blocking all playback. */ }
      }
      if (!disposed && current === attempt) onState('play');
    }
  };
  const resume = () => { void play(); };
  const watch = track => {
    if (tracks.has(track)) return;
    tracks.add(track);
    track.addEventListener('unmute', resume);
  };
  const added = event => { watch(event.track); resume(); };
  const visible = () => { if (document.visibilityState === 'visible') resume(); };
  element.srcObject = stream || null;
  element.muted = muted;
  onState(null);
  stream?.getTracks().forEach(watch);
  stream?.addEventListener('addtrack', added);
  element.addEventListener('loadedmetadata', resume);
  document.addEventListener('visibilitychange', visible);
  resume();
  return {
    play: () => play(true),
    dispose() {
      disposed = true;
      attempt++;
      stream?.removeEventListener('addtrack', added);
      tracks.forEach(track => track.removeEventListener('unmute', resume));
      element.removeEventListener('loadedmetadata', resume);
      document.removeEventListener('visibilitychange', visible);
      element.srcObject = null;
    }
  };
}
